function Tabs() {
  const tabButtons = document.querySelectorAll(".tab-btn");
  const tabContents = document.querySelectorAll(".tab-content");

  if (!tabButtons.length || !tabContents.length) return;

  function activateTab(index) {
    tabButtons.forEach((btn) => btn.classList.remove("active"));
    tabContents.forEach((content) => content.classList.remove("active"));

    tabButtons[index].classList.add("active");
    tabContents[index].classList.add("active");
  }

  activateTab(0);

  // Click events
  tabButtons.forEach((btn, index) => {
    btn.addEventListener("click", () => activateTab(index));
  });
}

export default Tabs;
